import { useState } from 'react';
import { Button, Paper } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { columns } from './grid-columns';
import { MunicipalityForm } from './municipality.form';
import { Municipality } from '../../../models/masters/municipality';
import { municipalityFormSchema } from './municipality-form.schema';
import { SiTrackGrid } from '../../../components/si-track-grid/si-track-grid';
import { SaveHookFormDialog } from '../../../components/save-hook-form.dialog';
import { municipalityApiKeyStore } from '../../../api/masters/municipality-api-key-store';
import { SiTrackPage } from '../../../components/si-track-page';
import { GuardedComponent } from '../../../components/guarded-component';
import { UserPermissionName } from '../../../models/user-permission-name';
import { useNavigate } from 'react-router-dom';

const styling = {
  paperStyle: { padding: '20px', borderRadius: '20px' },
};

export const MunicipalityPage = () => {
  const navigate = useNavigate();
  const [editItem, setEditItem] = useState<Partial<Municipality>>();

  const handleEditMunicipality = (municipality: Municipality) => {
    // setEditItem(municipality);
    navigate(`/masters/municipality/edit/${municipality?.municipalityID}`);
  };

  const handleEditClose = () => {
    setEditItem(undefined);
  };

  const handleCreateMunicipality = () => {
    navigate('/masters/municipality/create');
    // setEditItem({});
  };

  return (
    <SiTrackPage
      title="Municipalities"
      actionButton={
        <GuardedComponent requiredPermissions={[UserPermissionName.ADD_MUNICIPALITY]}>
          <Button
            size="small"
            variant="contained"
            disableElevation={true}
            startIcon={<AddIcon />}
            onClick={handleCreateMunicipality}
          >
            Add Municipality
          </Button>
        </GuardedComponent>
      }
    >
      <Paper elevation={0} style={styling.paperStyle}>
        <SiTrackGrid
          fileTitle='municipality'
          dataItemKey="municipalityID"
          columns={columns}
          viewRoute={(value) => `details/${value.municipalityID}`}
          queryConfig={municipalityApiKeyStore.getMunicipalities()}
          onEdit={handleEditMunicipality}
          deleteMutationConfig={(deleteItem) => municipalityApiKeyStore.deleteMunicipality(deleteItem.municipalityID)}
          actionPermissions={{
            edit: UserPermissionName.EDIT_MUNICIPALITY,
            delete: UserPermissionName.DELETE_MUNICIPALITY,
            export: UserPermissionName.DOWNLOAD_GRID
          }}
        />
        {editItem && (
          <SaveHookFormDialog
            title={editItem.municipalityID ? 'UPDATE MUNICIPALITY' : 'CREATE MUNICIPALITY'}
            config={{
              saveConfig: editItem.municipalityID
                ? municipalityApiKeyStore.updateMunicipality()
                : municipalityApiKeyStore.createMunicipality(),
              invalidateRoute: () => municipalityApiKeyStore.getMunicipalities(),
            }}
            data={editItem}
            yupSchema={municipalityFormSchema}
            onClose={handleEditClose}
            size="xs"
          >
            <MunicipalityForm />
          </SaveHookFormDialog>
        )}
      </Paper>
    </SiTrackPage>
  );
};
